if (!customElements.get('variant-label')) {
    class VariantLabel extends HTMLElement {
      constructor() {
        super();
        this.productCard = null;
        this.variantLabels = [];
        this.variantObserver = null;
        this.showVdayHeart = false;
      }
  
      connectedCallback() {
        this.initialize();

        // Always run initial label render so badges show on static cards
        this.updateLabel();

        // Skip event listeners for static product cards (pre-rendered, variant won't change)
        if (this.productCard && this.productCard.hasAttribute('data-static')) {
          return;
        }

        this.setupEventListeners();
      }
  
      disconnectedCallback() {
        this.cleanup();
      }
  
      initialize() {
        // Find parent product-card element
        this.productCard = this.closest('product-card');
        
        // Get variant labels from data attribute
        const variantLabelsData = this.getAttribute('data-variant-labels');
        if (variantLabelsData) {
          try {
            this.variantLabels = JSON.parse(variantLabelsData);
          } catch (e) {
            this.variantLabels = [];
          }
        }
        
        // Get show_vday_heart setting
        this.showVdayHeart = this.getAttribute('data-show-vday-heart') === 'true';
      }
  
      setupEventListeners() {
        if (!this.productCard) {
          return;
        }
        
        // Watch for changes to data-variant-id on the product-card
        this.variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-variant-id') {
              this.updateLabel();
            }
          });
        });
        
        this.variantObserver.observe(this.productCard, {
          attributes: true,
          attributeFilter: ['data-variant-id']
        });
      }
  
      updateLabel() {
        if (!this.productCard) {
          return;
        }

        const variantIdAttr = this.productCard.getAttribute('data-variant-id');
        if (!variantIdAttr) {
          return;
        }

        const variantId = parseInt(variantIdAttr);
        const variantData = this.variantLabels.find(v => {
          const vId = typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
          return vId === variantId;
        });

        if (!variantData || !variantData.label) {
          // Hide element if no label data
          this.style.setProperty('display', 'none', 'important');
          return;
        }

        const labelSpan = this.querySelector('.variant-label-text');
        if (labelSpan) {
          labelSpan.textContent = variantData.label;
        }

        // Show the element when there's a valid label (remove inline display to let CSS classes apply)
        this.style.removeProperty('display');

        // Update background color
        if (this.showVdayHeart) {
          this.style.backgroundColor = 'transparent';
        } else {
          this.style.backgroundColor = variantData.colour || 'red';
        }
      }
  
      cleanup() {
        if (this.variantObserver) {
          this.variantObserver.disconnect();
          this.variantObserver = null;
        }
      }
    }
  
    customElements.define('variant-label', VariantLabel);
  }
  
  